import styled, { css } from 'styled-components';

const RadioInput = styled.input`
  /* take it out of document flow */
  position: absolute;
  /*  hide it */
  opacity: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;

  & + label {
    position: relative;
    display: inline-block;
    vertical-align: top;
    padding-left: 24px;
    cursor: pointer;
    line-height: 20px;
  }

  & + label:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    transition: all 0.5s ease;

    ${({ withNoBorderWhenUnselected, theme }) =>
      !withNoBorderWhenUnselected &&
      css`
        border: 1px solid ${theme.defaultColors.darkGrey};
      `};

    ${({ withFilledBackgroundWhenUnselected, theme }) =>
      withFilledBackgroundWhenUnselected &&
      css`
        background: ${theme.defaultColors.lightGrey};
      `};
  }

  &:checked + label:after {
    content: '';
    display: block;
    position: absolute;
    top: 7px;
    left: 6px;
    width: 9px;
    height: 4px;
    border-left: 1px solid transparent;
    border-bottom: 1px solid transparent;
    border-color: #fff;
    transform: rotate(-45deg);
    transition: border-color 0.5s ease;
  }

  &:checked + label:before {
    background: ${({ theme }) => theme.customColors.primary};
    border-color: ${({ theme }) => theme.customColors.primary};
  }

  &:disabled + label {
    color: ${({ theme }) => theme.defaultColors.fontSecondary};
    cursor: default;
  }

  &:disabled + label:before {
    border: 1px solid ${({ theme }) => theme.defaultColors.fontSecondary};
    background: ${({ theme }) => theme.defaultColors.lightGrey};
  }
`;

/** @component */
export default RadioInput;
